<div class="modal-container">
  <div class="dialog-header">
    <h2>Add user to {{ data.accountNumber }}</h2>
    <button mat-icon-button aria-label="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if (confirmation(); as result) {
      <div class="confirmation">
        <mat-icon class="success-icon">check_circle</mat-icon>
        @if (result.outcome === "invited") {
          <p>
            <strong>{{ result.email }}</strong> was successfully invited to
            Dealer Portal for account {{ result.accountNumber }}.
          </p>
        } @else {
          <p>
            Account {{ result.accountNumber }} was successfully added to
            <strong>{{ result.email }}</strong
            >. They've been notified by email.
          </p>
        }
        <button mat-flat-button color="primary" (click)="close()">Done</button>
      </div>
    } @else {
      <app-create-dealer-user
        [accountNumber]="data.accountNumber"
        (dealerUserSaved)="onSaved($event)"
      ></app-create-dealer-user>
    }
  </mat-dialog-content>
</div>
